import {
    CONVERT_INCH_METER,
    LENGTH,
    AREA,
    UNIT_METER,
    CONVERT_METER_INCH,
    UNIT_FOOT,
    CONVERT_FOOT_METER
} from "../constants";
import {convertMetric} from "./metric";
import {isEdge} from './detectBrowser';

export const convertMetricInchMeter = (size) => {
    return convertMetric(size, LENGTH, true, CONVERT_INCH_METER, true, true, 1);
}

export const convertMetricMeterInch = (size) => {
    return convertMetric(size, LENGTH, true, CONVERT_METER_INCH, true, true, 1);
}

export const roundNumber = (value, fraction = 2) => {
    return parseFloat(value).toFixed(fraction);
}

export const getCustomAreaString = ({width, unit, square, length}, metrical, areaString) => {
    let squareRoom = square;
    let unitScene = metrical ? UNIT_METER : UNIT_FOOT;
    const code = isEdge ? '' : String.fromCharCode(0xb2);
    if (width == 0 && length == 0 || typeof width === 'undefined' || typeof length === 'undefined') return areaString;

    if (unit === UNIT_METER && unitScene === UNIT_FOOT) {
        if(!squareRoom) squareRoom = width * length;
        let {value: valueSquareRoom} = convertMetric(squareRoom,  AREA, metrical, UNIT_METER, true, true, 1);
        squareRoom = valueSquareRoom;

        let {value: valueWidth, unit: unitWidth} = convertMetric(width,  LENGTH, metrical, UNIT_METER, true, true, 1);
        width = valueWidth;
        unitScene = unitWidth;

        let {value: valueLength, unit: unitLength} = convertMetric(length,  LENGTH, metrical, UNIT_METER, true, true, 1);
        length = valueLength;
        unitScene = unitLength;
    }

    if (unit === UNIT_FOOT && unitScene === UNIT_METER) {
        if(!squareRoom) squareRoom = width * length;
        let {value: valueWidth, unit: unitWidth} = convertMetricFootMeter(width);
        width = valueWidth;
        unitScene = unitWidth;

        let {value: valueLength, unit: unitLength} = convertMetricFootMeter(length);
        length = valueLength;
        unitScene = unitLength;

        let {value: valueSquareRoom} = convertMetricFootMeter(squareRoom);
        squareRoom = valueSquareRoom;
    }

    if (unit === UNIT_FOOT && unitScene === UNIT_FOOT) {
        width = width + UNIT_FOOT;
        length = length + UNIT_FOOT;
    }


        areaString = metrical
        ? `${width}x${length}${unitScene}, ${squareRoom || width*length}${unitScene}${code}`
        : `${width}x${length}, ${squareRoom || width*length}${unitScene}${code}`;

    return areaString;
}

export const convertMetricFootMeter = (size) => {
    return convertMetric(size, LENGTH, true, CONVERT_FOOT_METER, true, true, 1);
}